import ModalCustom from "components/common/ModalCustom/ModalCustom";
import Notification from "components/common/notification/notification";
import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Spin } from "antd";
import { center } from '@antv/g2plot/lib/plots/sankey/sankey';

//pass error "WorkerMessageHandler"
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfViewer = ({ modalViewer, filePdf }) => {
  const [numPages, setNumPages] = useState(1);
  const onLoadPageDocument = (pdf: { numPages: number }) => {
    setNumPages(pdf.numPages);
  };

  return (
    <ModalCustom ref={modalViewer} width={1000}>
    <div style={{marginLeft:"160px"}}>
    <Document
        noData={"không có data"}
        loading={<Spin />}
        onLoadSuccess={onLoadPageDocument}
        onLoadError={(error) => {
          Notification("error", "Đã xảy ra lỗi khi tải file pdf");
        }}
        file={filePdf as Blob}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        ))}
      </Document>
    </div>
    </ModalCustom>
  );
};

export default PdfViewer;
